import React, { useState, useEffect } from "react";
import "./App.css";
import { FiSearch, FiMenu} from "react-icons/fi";

function Header() {

  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {

  }, );

    const refreshPage = () => {
    window.location.href = "/";
    window.location.reload();
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        
        <div className="navbar-logo" onClick={refreshPage} style={{ cursor: "pointer" }}>
          <img src="./LOGO.png" alt="logo" className="logo-image" />
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>
          <a href="/home">Home</a>
          <a href="/About">About</a>
          <a href="/Services">Services</a>
          <a href="/Portfolio">Portfolio</a>
        </div>

        <div className="nav-actions">
          <div className="search-box">
            <button
              className="icon-btn"
              onClick={() => setSearchOpen(!searchOpen)}
            >
              <FiSearch />
            </button>

            <input
              type="text"
              placeholder="Search..."
              className={`search-input ${searchOpen ? "active" : ""}`}
            />
          </div>

          <div
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <FiMenu />
          </div>

        </div>
      </div>
    </nav>
  );
}

export default Header;
